import React, { useState, useEffect } from 'react'
import FastAnimatedC from 'src/assets/FastAnimatedC.gif'
import Sparkle from 'src/assets/ai-sparkle.svg'

const STATUSES = [
  'Reviewing your documentation...',
  'Confirming encounter details...',
  'Evaluating MDM and level of care...',
  'Assessing clinical risk and documentation support...',
  'Validating CPT and diagnosis codes...',
  'Finalizing your code check...',
]

export default function AiCodeCheckSpinner() {
  const [textIndex, setTextIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTextIndex((prevIndex) => {
        const nextIndex = prevIndex + 1
        return nextIndex >= STATUSES.length ? 0 : nextIndex
      })
    }, 3200)
    return () => clearInterval(intervalId)
  }, [textIndex])

  return (
    <div className={'d-flex flex-column align-items-center'}>
      <img className={'cSpinner h-50 w-50'} src={FastAnimatedC} alt="Claimocity C" />
      <div className={'d-flex align-items-center justify-content-center gap-2'}>
        <img
          style={{ width: '1.25em' }}
          className={'sparkle'}
          src={Sparkle}
          alt="Blue to red hued gradient in the shape of a 4 pointed star"
        />{' '}
        <b>Running AI Code Check</b>
      </div>
      <p className={'mt-3 ms-4'} style={{ fontSize: '0.9em' }}>
        {STATUSES[textIndex]}
      </p>
    </div>
  )
}
